import React from 'react'
// import { useTypePosition } from '../context/useTypePosition'

import TypePositionList from './TypePositionList'
import { Container, Paper } from '@mui/material'
import { TypePositionEdit } from './TypePositionEdit/TypePositionEdit'
import { TypePositionSearch } from './TypePositionSearch/TypePositionSearch'
import { SnackBar } from '../../SnackBar/Snackbar'
import { useTypePosition } from '../context'
/*
Copyright 2022-11-18 por alfonso moya Ecomsur Holding S.A ©
Detalle: Se agrega actionTypes
*/
const TypePositionWrapper = () => {
  const {
    state: { snackbarState }
  } = useTypePosition()
  return (
    <Container maxWidth='xl'>
      <TypePositionSearch />

      <Paper elevation={3}>
        <TypePositionList />
        <TypePositionEdit />
      </Paper>

      <SnackBar {...snackbarState} />
    </Container>
  )
}

export default TypePositionWrapper
